import React from "react";
import { Link, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

export default function MasterV2() {
  return;
  const { pathname } = useLocation();
  const hasAccess = usePrivateLink();

  const studentMenus = [
    {
      path: "/student/attendance/dashboard/v2",
      label: "Overview",
      icon: "ri-dashboard-3-line",
      exact: true,
    },
    {
      path: "/attendance/mark",
      label: "Mark Attendance",
      icon: "ri-user-follow-line",
    },
    {
      path: "/attendance/reports/day-wise",
      label: "Day Wise",
      icon: "ri-calendar-check-line",
    },
    {
      path: "/attendance/reports/monthly",
      label: "Monthly",
      icon: "ri-calendar-2-line",
    },
    {
      path: "/attendance/reports/annual",
      label: "Annual",
      icon: "ri-calendar-todo-line",
    },
    {
      path: "/attendance/reports/low-attendance",
      label: "Low Attendance",
      icon: "ri-user-unfollow-line",
    },
    {
      path: "/attendance/reports/message-delivery",
      label: "Message Delivery",
      icon: "ri-message-3-line",
    },
    {
      path: "/attendance/reports/admission-month-wise",
      label: "Admission Month Wise",
      icon: "ri-user-search-line",
    },
    {
      path: "/student/attendance/followups",
      label: "Follow-ups",
      icon: "ri-phone-line",
    },
  ];

  const isActive = (item) => {
    if (item.exact) return pathname === item.path;
    return pathname === item.path || pathname.startsWith(`${item.path}/`);
  };

  const visibleMenus = studentMenus.filter((item) => {
    try {
      return hasAccess(item.path);
    } catch (error) {
      return false;
    }
  });

  return (
    <>
      <div className="attendance-v2-master">
        <div className="attendance-v2-master-head">
          <div className="attendance-v2-brand">
            <div className="attendance-v2-brand-icon">
              <i className="ri-bar-chart-box-line"></i>
            </div>
            <div className="attendance-v2-brand-copy">
              <div className="attendance-v2-brand-title-row">
                <strong>Student Attendance</strong>
                <span>V2</span>
              </div>
              <small>Attendance management & reporting</small>
            </div>
          </div>

          {/* <div className="attendance-v2-master-actions">
            {hasAccess("/student/attendance/dashboard") && (
              <Link
                to="/student/attendance/dashboard"
                className="attendance-v2-classic-btn"
              >
                <i className="ri-arrow-left-line"></i>
                <span>Classic Dashboard</span>
              </Link>
            )}
          </div> */}
        </div>

        <div className="attendance-v2-menu-scroll">
          <div className="attendance-v2-menu">
            {visibleMenus.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`attendance-v2-menu-item ${
                  isActive(item) ? "active" : ""
                }`}
              >
                <span className="attendance-v2-menu-icon">
                  <i className={item.icon}></i>
                </span>
                <span className="attendance-v2-menu-label">{item.label}</span>
                {item.path === "/attendance/reports/low-attendance" && (
                  <span className="attendance-v2-important-dot"></span>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .attendance-v2-master {
          width: 100%;
          background: #ffffff;
          border: 1px solid #e4e7ec;
          border-radius: 15px;
          box-shadow: 0 3px 16px rgba(16, 24, 40, 0.045);
          overflow: hidden;
        }

        .attendance-v2-master-head {
          min-height: 64px;
          padding: 10px 13px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          border-bottom: 1px solid #eef0f3;
          background: linear-gradient(180deg, #ffffff 0%, #fcfcff 100%);
        }

        .attendance-v2-brand {
          min-width: 0;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .attendance-v2-brand-icon {
          width: 40px;
          height: 40px;
          flex: 0 0 40px;
          border-radius: 11px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 19px;
          background: linear-gradient(135deg, #696cff, #7c3aed);
          box-shadow: 0 5px 13px rgba(105, 108, 255, 0.22);
        }

        .attendance-v2-brand-copy {
          min-width: 0;
          display: flex;
          flex-direction: column;
        }

        .attendance-v2-brand-title-row {
          display: flex;
          align-items: center;
          gap: 7px;
        }

        .attendance-v2-brand-title-row strong {
          color: #25293c;
          font-size: 14px;
          line-height: 1.2;
          font-weight: 800;
        }

        .attendance-v2-brand-title-row span {
          padding: 2px 6px;
          border-radius: 6px;
          color: #6d28d9;
          background: #f1eafe;
          border: 1px solid #e3d5ff;
          font-size: 8px;
          line-height: 1.2;
          font-weight: 900;
          letter-spacing: .45px;
        }

        .attendance-v2-brand-copy small {
          margin-top: 3px;
          color: #98a2b3;
          font-size: 10px;
          font-weight: 600;
        }

        .attendance-v2-master-actions {
          flex-shrink: 0;
        }

        .attendance-v2-classic-btn {
          min-height: 36px;
          padding: 0 11px;
          border: 1px solid #e0e4eb;
          border-radius: 9px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          color: #667085;
          background: #ffffff;
          text-decoration: none;
          font-size: 10.5px;
          font-weight: 700;
          transition: all .18s ease;
        }

        .attendance-v2-classic-btn:hover {
          color: #5b21b6;
          border-color: #d8c8fa;
          background: #faf8ff;
        }

        .attendance-v2-menu-scroll {
          width: 100%;
          overflow-x: auto;
          scrollbar-width: thin;
          scrollbar-color: #d9dce4 transparent;
        }

        .attendance-v2-menu-scroll::-webkit-scrollbar {
          height: 4px;
        }

        .attendance-v2-menu-scroll::-webkit-scrollbar-thumb {
          background: #d9dce4;
          border-radius: 20px;
        }

        .attendance-v2-menu {
          min-width: max-content;
          padding: 7px 10px;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .attendance-v2-menu-item {
          position: relative;
          min-height: 38px;
          padding: 5px 10px 5px 6px;
          border: 1px solid transparent;
          border-radius: 9px;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: #667085;
          background: transparent;
          text-decoration: none;
          white-space: nowrap;
          font-size: 11px;
          font-weight: 700;
          transition: all .18s ease;
        }

        .attendance-v2-menu-item:hover {
          color: #344054;
          background: #f8f9fc;
          border-color: #eaecf0;
        }

        .attendance-v2-menu-icon {
          width: 27px;
          height: 27px;
          border-radius: 7px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #667085;
          background: #f2f4f7;
          font-size: 14px;
          transition: all .18s ease;
        }

        .attendance-v2-menu-item.active {
          color: #5b21b6;
          border-color: #e2d8fb;
          background: linear-gradient(135deg, #f7f3ff, #f1f3ff);
        }

        .attendance-v2-menu-item.active .attendance-v2-menu-icon {
          color: #ffffff;
          background: linear-gradient(135deg, #696cff, #7c3aed);
          box-shadow: 0 3px 8px rgba(105, 108, 255, .18);
        }

        .attendance-v2-important-dot {
          width: 5px;
          height: 5px;
          margin-left: -2px;
          border-radius: 50%;
          background: #ea5455;
        }

        @media (max-width: 767px) {
          .attendance-v2-master {
            border-radius: 12px;
          }

          .attendance-v2-master-head {
            min-height: 58px;
            padding: 9px 10px;
          }

          .attendance-v2-brand-icon {
            width: 36px;
            height: 36px;
            flex-basis: 36px;
            font-size: 17px;
          }

          .attendance-v2-brand-title-row strong {
            font-size: 12px;
          }

          .attendance-v2-brand-copy small {
            font-size: 9px;
          }

          .attendance-v2-classic-btn {
            width: 35px;
            height: 35px;
            min-height: 35px;
            padding: 0;
          }

          .attendance-v2-classic-btn span {
            display: none;
          }

          .attendance-v2-menu {
            padding: 6px 8px;
          }

          .attendance-v2-menu-item {
            min-height: 36px;
            font-size: 10.5px;
          }
        }
      `}</style>
    </>
  );
}
